import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { DEFAULT_COMMISSION_RATE } from "../lib/pricing";

// Platform-wide configuration (admin-editable in a later phase). Stored at
// platformConfig/global. Falls back to defaults if the doc/rule is not present yet,
// so pricing never breaks. Each payment transaction snapshots the rate it used.
export async function getPlatformConfig() {
  try {
    const snap = await getDoc(doc(db, "platformConfig", "global"));
    if (snap.exists()) {
      const d = snap.data();
      const rate = Number(d.commissionRate);
      return {
        commissionRate: Number.isFinite(rate) && rate > 0 && rate < 1 ? rate : DEFAULT_COMMISSION_RATE,
      };
    }
  } catch {
    /* not configured yet — use defaults */
  }
  return { commissionRate: DEFAULT_COMMISSION_RATE };
}

export async function getCommissionRate() {
  const cfg = await getPlatformConfig();
  return cfg.commissionRate;
}
